import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export interface FilterChipOption {
  id: string;
  label: string;
  ariaLabel?: string;
  disabled?: boolean;
}

@Component({
  selector: 'bai-filter-chip-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './filter-chip-group.component.html',
  styleUrl: './filter-chip-group.component.scss',
})
export class FilterChipGroupComponent {
  readonly options = input<readonly FilterChipOption[]>([]);
  readonly selected = input<string | readonly string[]>('');
  readonly multiSelect = input(false);
  readonly ariaLabel = input('Filter options');

  readonly selectionChange = output<string | string[]>();

  isSelected(id: string): boolean {
    const selected = this.selected();
    return Array.isArray(selected) ? selected.includes(id) : selected === id;
  }

  onSelect(id: string): void {
    if (this.multiSelect()) {
      const current = this.selected();
      const selected = Array.isArray(current)
        ? [...current]
        : current
          ? [current]
          : [];
      const next = selected.includes(id)
        ? selected.filter((item) => item !== id)
        : [...selected, id];
      this.selectionChange.emit(next);
      return;
    }

    this.selectionChange.emit(id);
  }

  trackById(_index: number, option: FilterChipOption): string {
    return option.id;
  }
}
